import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { paymentActions } from '../actions/payment.actions';
import { asyncScheduler, catchError, map, switchMap, tap } from 'rxjs';
import { paymentApiActions } from '../actions/payment-api.actions';
import { LinkApiService } from '../../services/link-api/link-api.service';
import { featureFlagsActions } from '@libs/utility-feature-flags/+state/actions/feature-flags.actions';
import { retryWithDelay } from '@libs/shared/utilities/grpc/retry-with-delay.operator';
import { Router } from '@angular/router';

@Injectable()
export class PaymentEffects {
  readonly #actions$ = inject(Actions);
  readonly #apiService = inject(LinkApiService);
  readonly #router = inject(Router);

  fetchLinkDetails$ = createEffect(
    () =>
      ({ scheduler = asyncScheduler, interval = 1000, times = 20 } = {}) =>
        this.#actions$.pipe(
          ofType(paymentActions.openLink),
          switchMap(({ linkId }) =>
            this.#apiService.getLinkDetails(linkId).pipe(
              retryWithDelay(times, interval, this.#actions$, scheduler),
              map((linkDetails) => paymentApiActions.linkDetailsLoadedSuccess({ linkDetails })),
              catchError((error) => [paymentApiActions.linkDetailsLoadedError({ error, linkId })]),
            ),
          ),
        ),
  );

  listenToFeatureFlags$ = createEffect(() =>
    this.#actions$.pipe(
      ofType(paymentActions.openLink),
      map(() => featureFlagsActions.initialize({ context: { anonymous: true } })),
    ),
  );

  handleLinkDetailsLoadError$ = createEffect(
    () =>
      this.#actions$.pipe(
        ofType(paymentApiActions.linkDetailsLoadedError),
        tap(({ linkId }) => {
          this.#router.navigate(['/error'], { queryParams: { paymentId: linkId }, queryParamsHandling: 'merge' });
        }),
      ),
    { dispatch: false },
  );
}
